module.exports = __webpack_public_path__ + "img/04.8d08ed56.png";